module.exports = __webpack_public_path__ + "img/iconoRegistro.6099925e.png";